/**
 * Company-logo upload types. The stored file's extension comes from the
 * VALIDATED MIME type, never from the user's file name (the server rule for a
 * stored logo URL is png|jpg|jpeg|webp, and the bucket allows these 3 types).
 */
const EXTENSION_BY_MIME = {
  'image/png': 'png',
  'image/jpeg': 'jpg',
  'image/webp': 'webp',
};

export function logoExtensionForMime(mime) {
  return Object.prototype.hasOwnProperty.call(EXTENSION_BY_MIME, mime) ? EXTENSION_BY_MIME[mime] : null;
}

export default logoExtensionForMime;
